import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { get } from 'js/utils/fetch.util';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import { IGamesFeed } from '../../types';
import { addGamesFeed } from '../../store/actions';

const REQUESTS: {
    [key: string]: Promise<IGamesFeed> | undefined;
} = {};

export const useGetGamesFeed = () => {
    const dispatch = useDispatch();
    const getCMSResourceURL = useGetCMSResourceURL();
    const formFactor = useDeviceSelector(prop('formFactor'));
    const requestStamp = useAppSelector(prop('requestStamp'));

    return useCallback(async (feedName: string): Promise<IGamesFeed> => {
        if (REQUESTS[feedName]) {
            return REQUESTS[feedName] as Promise<IGamesFeed>;
        }

        REQUESTS[feedName] = new Promise((resolve, reject) => {
            const gamesFeedURL = getCMSResourceURL(`/initialResources/gamesFeeds/${encodeURIComponent(feedName)}`, { t: requestStamp });

            get(gamesFeedURL).then((gamesFeed) => {
                const response = helpers.parseGamesFeed({ gamesFeed, formFactor });

                dispatch(addGamesFeed(response));

                resolve(response);
            })
            .catch(() => {
                reject(`[Games] unable to get games feed "${gamesFeedURL}"`);
                REQUESTS[feedName] = undefined;
            });
        });

        return REQUESTS[feedName] as Promise<IGamesFeed>;
    }, [dispatch, formFactor, getCMSResourceURL, requestStamp]);
};
